/**
 * Loads the activity tracker asynchronously in its own chunk (MD-0099).
 * Start immediately: an idle timeout would miss the first interactions. Never throws.
 */

import type { ensureActivityTracking as EnsureActivityTracking } from './index';

type RouterArg = Parameters<typeof EnsureActivityTracking>[0];

let scheduled = false;

export function scheduleActivityTracking(router: RouterArg): void {
  if (scheduled || typeof window === 'undefined') return;
  scheduled = true;
  import('./index')
    .then(({ ensureActivityTracking }) => {
      ensureActivityTracking(router);
    })
    .catch(() => {
      // Telemetry is optional: a failed chunk load leaves the app untouched.
    });
}
